/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/de-circle': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: `
      <g clip-path="url(#clip0_340_1333)">
      <mask id="mask0_340_1333" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="61">
      <path d="M59.9985 0H0.000976562V60.9972H59.9985V0Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_340_1333)">
      <path d="M15.8089 -1.99634H-14.1902V22.8095H15.8089V-1.99634Z" fill="#004073"/>
      <path d="M15.8089 35.1736H-14.1902V59.9794H15.8089V35.1736Z" fill="#003F73"/>
      <path d="M15.8089 22.7954H-14.1902V35.1983H15.8089V22.7954Z" fill="#FFCC00"/>
      <path d="M27.6852 -2.03149H15.6855V59.983H27.6852V-2.03149Z" fill="#FFCC00"/>
      <path d="M81.3027 22.7991H27.3044V35.202H81.3027V22.7991Z" fill="#FFCC00"/>
      <path d="M81.6731 35.1775H27.6748V59.9833H81.6731V35.1775Z" fill="#003F73"/>
      <path d="M81.6731 -1.99634H27.6748V22.8095H81.6731V-1.99634Z" fill="#003F73"/>
      <path d="M71 39.3113H-11V59.9835H71V39.3113Z" fill="#FFE600"/>
      <path d="M71 -2.03296H-11V18.6392H71V-2.03296Z" fill="black"/>
      <path d="M71 18.6392H-11L-11 39.3113H71V18.6392Z" fill="#FF0000"/>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_340_1333">
      <rect width="60" height="60" rx="30" fill="white"/>
      </clipPath>
      </defs>
    `
  }
})
